import { Box, Button, Input, Text } from '@chakra-ui/react';
import { getResponse } from '@waitroom/common-api';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { Response } from '../../../../core/components/Form/Form';
import { FormControl } from '../../../../core/components/FormControl/FormControl';
import SocialAuth from '../../Social/Social';
import { LoginFormProps } from './LoginForm.types';
import { useLoginForm } from './useLoginForm';

const buttonProps = {
  size: { base: 'sm', sm: 'def', md: 'def' },
};
const inputSize = { base: 'sm', sm: 'def' };
const LoginForm = ({
  children,
  showResponse = true,
  onCompleted,
  ...rest
}: LoginFormProps): ReactElement | null => {
  const {
    t,
    methods: {
      handleSubmit,
      register,
      formState: { errors },
    },
    submit,
    mutation,
  } = useLoginForm(rest);

  return (
    <form data-id="Login" onSubmit={handleSubmit(submit)}>
      <Box mb={6}>
        <Text mb={4} letterSpacing="tight">
          <Trans i18nKey="auth.loginExplanation" />
        </Text>
        <Box mb={2}>
          <FormControl error={errors.email}>
            <Input
              size={inputSize}
              type="email"
              placeholder={t('global.enterYourEmail')}
              {...register('email')}
            />
          </FormControl>
        </Box>
        {showResponse && mutation.error && Object.keys(errors).length === 0 ? (
          <Response mb={2} response={getResponse(mutation.error)} namespace="responses.login." />
        ) : null}
        {children}
      </Box>
      <Button
        w="100%"
        colorScheme="red"
        size={buttonProps.size}
        isLoading={mutation.isPending}
        type="submit"
        id="submit-email-login"
        data-id="email-login"
      >
        {t('global.logInWithEmail')}
      </Button>
      <Box my={[4, 5, 6]} textAlign="center" fontSize="large" fontWeight="bold" color="gray.500">
        {t('global.OR')}
      </Box>
      <SocialAuth
        mb={4}
        onCompleted={onCompleted}
        redirectUrl={rest.redirectUrl}
        clientId={rest.clientId}
        state={rest.state}
        codeChallenge={rest.codeChallenge}
        buttonProps={buttonProps}
        isSignup={false}
      />
    </form>
  );
};

export default LoginForm;
